import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Shift } from 'src/app/classes/shift';
import { Organization } from 'src/app/classes/organization';
import ShiftTypes from 'src/app/constants/shift-types';
import { SettingsService } from 'src/app/services/settings.service';
import { ShiftService } from 'src/app/services/shift.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})

export class DetailsComponent  implements OnInit {
  shift!: Shift
  organization = new Organization()
  shiftTypes = ShiftTypes

  constructor(
    private shiftService: ShiftService,
    private settingsService: SettingsService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    forkJoin({
      organization: this.settingsService.organization(),
      shift: this.shiftService.shift(this.shift.id)
    }).subscribe(({ organization, shift }) => {
      this.organization = organization;
      this.shift = shift;
    });
  }
}
